module.exports = __webpack_public_path__ + "img/clas.bdcebef5.png";